import { FormattedMessage } from 'react-intl';

import type { FiltersGroup } from '@sorare/core/src/lib/filters';
import { navLabels } from '@sorare/core/src/lib/glossary';

import {
  RefineBackendPosition,
  RefineCompetitionEligibility,
  RefinePosition,
} from 'searchCards';
import { MatchInfoGroup, PlayerGroup } from 'searchCards/football/cardFilters';

import { FloorPricesGroup } from './common';

export const CompetitionEligibilityGroup = {
  slug: 'eligibility',
  title: <FormattedMessage {...navLabels.gamingCompetitions} />,
  filters: [RefineCompetitionEligibility],
};

export const scoutingCenterMarketFilters: FiltersGroup[] = [
  FloorPricesGroup,
  PlayerGroup({
    withPositions: true,
    withPlayingStatus: true,
  }),
  MatchInfoGroup,
];

export const scoutingCenterMarketDropdownFilters = [RefinePosition()];
export const scoutingCenterBackendMarketDropdownFilters = [
  RefineBackendPosition(),
];
